<template>
  <div>
    <a-spin :spinning="loading">
      <div class="neo-tabs-fees">
        <a-checkbox class="mb-2" default-checked @change="showHideStudentListPane">Show/Hide Student List</a-checkbox>
        <a-tabs :tabPosition="this.settings['isMobileView'] ? 'top' : 'left'">
          <a-tab-pane
            v-for="student in data"
            :tab="`(${student.student_code}) ${student.first_name} ${student.last_name} `"
            :key="student.id"
          >
          <display-student-fees :data="student" :rolesetting="rolesetting" @updateStudentFeeTable="handleEdited"/>
        </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>

    <add-student-fee @edited="handleEdited" />
    <edit-student-fee @edited="handleEdited" />
    <pay-student-fee @paid="handleEdited" />
    <edit-paid-fee @editedPaidFee="handleEdited" />
    <pay-all-student-fees @paid="handleEdited" />
    <student-fee-payment />
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'

import DisplayStudentFees from '@/components/feemanagement/payment/Fees/index'
import AddStudentFee from '@/components/feemanagement/payment/Forms/AddFee/index'
import EditStudentFee from '@/components/feemanagement/payment/Forms/Edit/index'
import PayStudentFee from '@/components/feemanagement/payment/Forms/Pay/index'
import EditPaidFee from '@/components/feemanagement/payment/Forms/EditPaidFee/index'
import PayAllStudentFees from '@/components/feemanagement/payment/Forms/PayAll/index'
import StudentFeePayment from '@/components/feemanagement/payment/Payment/index'

import { feeTypes } from '@/services/globaldata'
import { find } from 'lodash'

export default {
  name: 'DisplayStudentsFeesList',
  components: {
    DisplayStudentFees,
    AddStudentFee,
    EditStudentFee,
    PayStudentFee,
    EditPaidFee,
    PayAllStudentFees,
    StudentFeePayment,
  },
  props: ['loading', 'data', 'rolesetting'],
  data: function () {
    return {
      feeTypes,
      dateFormat: 'DD-MM-YYYY',
      selectedStudent: this.intialStudent,
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  methods: {
    moment,
    find,
    handleEdited: function () {
      this.$emit('updateTable')
    },
    showHideStudentListPane: function (event) {
      console.log(event.target.checked)
      const navContainer = document.querySelector('.ant-tabs-nav-container')
      if (navContainer) {
        if (event.target.checked) {
          navContainer.style.display = 'block'
        } else {
          navContainer.style.display = 'none'
        }
      }
    },
  },
}
</script>
